import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './App';
import { FIREBASE_API_KEY, FIREBASE_PROJECT_ID } from './constants';
import reportWebVitals from './reportWebVitals';

const StackdriverErrorReporter = require('stackdriver-errors-js');

const errorHandler = new StackdriverErrorReporter();
errorHandler.start({
  key: FIREBASE_API_KEY,
  projectId: FIREBASE_PROJECT_ID,
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
